'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.track = track;

var _constants = require('./constants');

var _getTrackPayload = require('./getTrackPayload');

var _getTrackPayload2 = _interopRequireDefault(_getTrackPayload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createAction(payload) {
  return {
    type: _constants.TRACK_EVENT,
    meta: _defineProperty({}, _constants.TRACK_EVENT, payload)
  };
}

function track(eventKey, eventProperties) {
  return createAction((0, _getTrackPayload2.default)(eventKey, eventProperties));
}